module.exports = __webpack_public_path__ + "static/takamol-ccb747376af2444734ae221a26fcae39.png";